
import React from "react";
import heroImage from '../assets/hero-image.jpeg';
import "./HeroBanner.css";
const HeroBanner = () => {
return (
    <section className="hero" id="home">
      <div className="hero-bg">
        <img src={heroImage} alt="Beautiful apartment interior" className="hero-bg-image" />
        <div className="hero-overlay"></div>
      </div>
      <div className="hero-content">
        <div className="hero-badge">🏠 Trusted To-Let Service in Hyderabad</div>
        <h1 className="hero-title">
          Looking for a<br />
          <span className="hero-highlight">To-Let Home?</span>
        </h1>
        <p className="hero-subtitle">
          Explore verified homes with free helper support and complimentary packing cartons. Move stress-free with RoomBuddy.
        </p>
        <div className="hero-actions">
          <a href="tel:+917989237393" className="hero-btn hero-btn-primary">
            📞 Call Us Now
          </a>
          <a href="https://play.google.com/store/apps/details?id=com.roombuddy.app" target="_blank" className="hero-btn hero-btn-primary">
            📱 Download App
          </a>
        </div>
        <div className="hero-stats">
          <div className="stat-item">
            <span className="stat-number">500+</span>
            <span className="stat-label">Happy Families</span>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <span className="stat-number">100%</span>
            <span className="stat-label">Verified Homes</span>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <span className="stat-number">All Areas</span>
            <span className="stat-label">Hyderabad</span>
          </div>
        </div>
      </div>
    </section>
  );
};
export default HeroBanner;